// "use client";

// import { useEffect } from "react";

// export default function OneTrustInitializer() {
//   useEffect(() => {
//     if (window.OneTrust) {
//       window.OneTrust.Init();
//     }
//   }, []);

//   return null;
// }

"use client";

import { useEffect } from "react";

export default function OneTrustInitializer() {
  useEffect(() => {
    const initializeOneTrust = () => {
      if (window.OneTrust) {
        window.OneTrust.Init();
      }
    };

    if (window.OneTrust) {
      initializeOneTrust();
      return;
    }

    const interval = setInterval(() => {
      if (window.OneTrust) {
        clearInterval(interval);
        initializeOneTrust();
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return null;
}
